
import Vue from 'vue'
import SERVICES from '@/constants/services'
import { mapGetters } from 'vuex'
import { LevelName } from './types/index'

export default Vue.extend({
  name: 'commonConfirmGAPopupChunk',
  props: {
    slotData: {
      type: Object,
      required: true
    }
  },
  watch: {
    'form.valid' (v) {
      const vm = this as any
      if (v && vm.form.fields.GACode.value.length > 0) {
        this.$store.commit('popupModule/setSlotData', { isLoading: true })
        setTimeout(() => {
          this.$emit('onSubmit', { code_ga: this.form.fields.GACode.value })
        }, 1000)
      }
    },
    'form.fields.GACode.value' () {
      this.$store.commit('popupModule/setSlotData', { responseErrors: [] })
    }
  },
  data () {
    return {
      form: {
        valid: false,
        fields: {
          GACode: {
            value: '',
            rules: [
              (v: string) => Boolean(v) || this.$t('common.errors.required'),
              (v: string) => v.length === SERVICES.CODE_LENGTH || this.$t('popups.numberCode', { length: SERVICES.CODE_LENGTH })
            ],
            errorsBucket: []
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters('user', ['getUserData']),
    servicesConst () {
      return SERVICES
    }
  },
  methods: {
    hasntAccessHandler () {
      this.$store.commit('popupModule/setClosed')
      const hasCurrentMethod = this.getUserData.currentAccessRepairMethods.includes('ga')
      const vm = this as any
      if (hasCurrentMethod) {
        this.$store.dispatch('alertsBus/openAlert', {
          title: vm.$t('alerts.titles.info'),
          type: 'info',
          autoDelete: true,
          content: vm.$t('popups.gotResetRequest')
        })
        return
      }
      const isBasic = this.getUserData.verificationRights.levelName === LevelName.basic
      if (isBasic) {
        vm.$store.dispatch('popupModule/openPopup', {
          type: 'confirmPopup',
          letDefaultClose: false,
          title: vm.$t('popups.titles.repairGA'),
          content: vm.$t('popups.content.toRepairGA'),
          actions: [
            {
              title: vm.$t('popups.actions.toSection'),
              isAccent: true,
              callback () {
                vm.$store.commit('popupModule/setClosed')
                vm.slotData.changeKycAccordionStatus(true)
              }
            },
            {
              title: vm.$t('popups.actions.later'),
              isAccent: false,
              callback () {
                vm.$store.commit('popupModule/setClosed')
              }
            }
          ]
        })
        return
      }
      this.$router.push({ name: 'AccessRepair', query: { secondFactor: 'ga', an3K8QkkJb3Mzz: this.slotData.sessionId } })
    }
  }
})
